<template>
  <div class="tier-row">
    <div class="columns is-mobile is-vcentered">
      <div class="column is-narrow">
        <img src="/img/grip-vertical-solid.png" class="drag-handle" />
      </div>
      <div class="column">
        <div class="columns">
          <div class="column">
            <div class="field">
              <label v-if="type != 'donation'" class="label"
                >Name of Tier</label
              >
              <label v-if="type == 'donation'" class="label"
                >Donation Title</label
              >
              <div class="control">
                <input
                  class="input is-primary"
                  type="text"
                  placeholder="Name of Tier"
                  v-model="tier.name"
                  @change="changed"
                  :disabled="disable"
                />
              </div>
              <p class="help is-danger" v-if="false">
                Please enter a name for this tier.
              </p>
            </div>
          </div>
          <div v-if="type != 'donation'" class="column is-one-quarter">
            <div class="field">
              <label class="label">Quantity Type</label>
              <div class="select is-fullwidth">
                <select
                  v-model="tier.quantityType"
                  @change="changed"
                  :disabled="disable"
                >
                  <option value="" v-if="!tier.feeType"></option>
                  <option value="fixed">Reserved</option>
                  <option value="flexible">Shared</option>
                </select>
              </div>
              <p class="help is-danger" v-if="false">
                Please select a quantity type.
              </p>
            </div>
          </div>
          <div v-if="type != 'donation'" class="column is-one-quarter">
            <div class="field">
              <label class="label">Tickets Available</label>
              <div class="control">
                <input
                  v-if="tier.quantityType == 'fixed'"
                  class="input is-primary"
                  type="number"
                  min="1"
                  max="10000"
                  step="1"
                  placeholder="# available"
                  v-model="tier.capacity"
                  :class="{
                    'is-danger': tier.capacity < 1 || tier.capacity > flexible
                  }"
                  @change="changed"
                  :disabled="disable"
                />
                <p
                  class="help is-danger"
                  v-if="tier.quantityType == 'fixed' && tier.capacity < 1"
                >
                  Capacity must be at least 1.
                </p>
                <p class="help is-danger" v-if="tier.capacity > flexible">
                  Tier capacity must be less than total capacity.
                </p>
                <input
                  v-if="tier.quantityType == 'flexible'"
                  disabled="true"
                  class="input is-primary"
                  type="number"
                  min="1"
                  max="10000"
                  step="1"
                  placeholder="# available"
                  v-model.number="flexible"
                  @change="changed"
                />
              </div>
              <p class="help is-danger" v-if="false">
                Please enter a name for this tier.
              </p>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-one-half">
            <div class="field">
              <label class="label">Tier Description (optional)</label>
              <div class="control">
                <textarea
                  class="textarea is-fullwidth"
                  v-model="tier.description"
                  @change="changed"
                  :disabled="disable"
                  rows="2"
                ></textarea>
              </div>
              <p class="help is-danger" v-if="false">
                Please enter a name for this tier.
              </p>
            </div>
          </div>
          <div class="column is-one-quarter">
            <div class="field">
              <label class="label">Fee Type</label>
              <div class="select is-fullwidth">
                <select
                  v-model="tier.feeType"
                  @change="changed"
                  :disabled="disable"
                >
                  <option value="" v-if="!tier.feeType"></option>
                  <option v-if="type != 'donation'" value="fixed"
                    >Fixed price</option
                  >
                  <option value="sliding">Sliding Scale</option>
                  <option v-if="type != 'donation'" value="free">Free</option>
                  <option v-if="type == 'donation'" value="tiers"
                    >Preset Tiers</option
                  >
                </select>
              </div>
              <p class="help is-danger" v-if="false">
                Please select a fee type.
              </p>
            </div>
            <div class="field" v-if="tier.feeType == 'sliding'">
              <label class="label">Suggested</label>
              <div class="control has-icons-left">
                <input
                  class="input is-primary"
                  type="number"
                  min="1"
                  max="10000"
                  step="1"
                  placeholder="price"
                  v-model.number="tier.price"
                  :class="{
                    'is-danger':
                      tier.price < tier.minPrice || tier.price > tier.maxPrice
                  }"
                  @change="changed"
                  :disabled="disable"
                />
                <span class="icon is-small is-left">
                  <i class="fas fa-dollar-sign"></i>
                </span>
              </div>
              <p
                class="help is-danger"
                v-if="tier.price < tier.minPrice || tier.price > tier.maxPrice"
              >
                Suggested price must be between min and max.
              </p>
            </div>
          </div>
          <div class="column is-one-quarter">
            <div class="field" v-if="tier.feeType == 'fixed'">
              <label class="label">Price</label>
              <div class="control has-icons-left">
                <input
                  class="input is-primary"
                  type="number"
                  min="5"
                  max="10000"
                  step="1"
                  placeholder="price"
                  v-model.number.lazy="tier.price"
                  :class="{ 'is-danger': tier.price && tier.price < 5 }"
                  @change="changed"
                  :disabled="disable"
                />
                <span class="icon is-small is-left">
                  <i class="fas fa-dollar-sign"></i>
                </span>
              </div>
              <p class="help is-danger" v-if="tier.price && tier.price < 5">
                Minimum ticket price is $5 (for now).
              </p>
              <p class="help is-danger" v-if="false">
                Please enter a valid price.
              </p>
            </div>

            <div class="field" v-if="tier.feeType == 'sliding'">
              <label class="label">Minimum</label>
              <div class="control has-icons-left">
                <input
                  class="input is-primary"
                  type="number"
                  min="5"
                  max="10000"
                  step="1"
                  placeholder="price"
                  v-model.number.lazy="tier.minPrice"
                  :class="{ 'is-danger': tier.minPrice && tier.minPrice < 5 }"
                  @change="changed"
                  :disabled="disable"
                />
                <span class="icon is-small is-left">
                  <i class="fas fa-dollar-sign"></i>
                </span>
              </div>
              <p
                class="help is-danger"
                v-if="tier.minPrice && tier.minPrice < 5"
              >
                Minimum ticket price is $5 (for now).
              </p>
            </div>
            <div class="field" v-if="tier.feeType == 'sliding'">
              <label class="label">Maximum</label>
              <div class="control has-icons-left">
                <input
                  class="input is-primary"
                  type="number"
                  min="1"
                  max="10000"
                  step=".01"
                  placeholder="price"
                  v-model.number.lazy="tier.maxPrice"
                  :class="{
                    'is-danger': tier.maxPrice && tier.maxPrice <= tier.minPrice
                  }"
                  @change="changed"
                  :disabled="disable"
                />
                <span class="icon is-small is-left">
                  <i class="fas fa-dollar-sign"></i>
                </span>
              </div>
              <p
                class="help is-danger"
                v-if="tier.maxPrice && tier.maxPrice <= tier.minPrice"
              >
                Maximum price must be more than the minimum price.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="type != 'donation'" class="column is-narrow">
        <div class="column is-narrow">
          <span
            class="icon is-medium delete"
            v-if="!disable"
            @click="deleted"
          ></span>
        </div>
      </div>
    </div>
    <div class="columns is-mobile">
      <div class="column is-narrow">
        <img
          src="/img/grip-vertical-solid.png"
          class="drag-handle"
          style="visibility: hidden"
        />
      </div>
      <div class="column">
        <div>
          <label class="checkbox">
            <input
              type="checkbox"
              v-model="tier.selectDates"
              :disabled="disable"
            />
            Apply tier to select dates only
          </label>
        </div>
        <div class="dates" v-if="tier.selectDates">
          <div
            class="date"
            v-for="date in dates"
            :key="date.id"
            :class="{ selected: tier.selectedDates.indexOf(date.id) > -1 }"
            @click="toggleDate(date)"
          >
            {{ shortDate(date.startDate) }}
          </div>
        </div>
        <div class="columns is-mobile sale-controls">
          <div class="column is-narrow">
            <label class="checkbox">
              <input
                type="checkbox"
                v-model="setOnSale"
                :disabled="disable"
                @change="onSaleToggled"
              />
              Set On Sale
            </label>
          </div>
          <div class="column is-narrow">
            <label class="checkbox">
              <input
                type="checkbox"
                v-model="setOffSale"
                :disabled="disable"
                @change="offSaleToggled"
              />
              Set Off Sale
            </label>
          </div>
        </div>
        <div
          class="columns is-multiline sale-datetime"
          v-if="setOnSale || setOffSale"
        >
          <div class="column is-narrow" v-if="setOnSale">
            <div class="field">
              <label class="label">On Sale Date</label>
              <div class="control">
                <duet-date-picker
                  :identifier="'onSaleDate-' + datepickerId"
                  :localization.prop="localisation_us"
                  :value="onSaleDate"
                  :disabled="disable"
                  first-day-of-week="0"
                  @duetChange="updateOnSaleDate"
                ></duet-date-picker>
              </div>
            </div>
          </div>
          <div class="column is-narrow" v-if="setOnSale">
            <div class="field">
              <label class="label">On Sale Time</label>
              <TimeField
                :time.sync="onSaleTime"
                :valid.sync="onSaleTimeValid"
                :disabled="disable"
                @change="onSaleDateTimeChanged"
              />
            </div>
          </div>
          <div class="column is-narrow" v-if="setOffSale">
            <div class="field">
              <label class="label">Off Sale Date</label>
              <div class="control">
                <duet-date-picker
                  :identifier="'offSaleDate-' + datepickerId"
                  :localization.prop="localisation_us"
                  :value="offSaleDate"
                  :disabled="disable"
                  first-day-of-week="0"
                  @duetChange="updateOffSaleDate"
                ></duet-date-picker>
              </div>
            </div>
          </div>
          <div class="column is-narrow" v-if="setOffSale">
            <div class="field">
              <label class="label">Off Sale Time</label>
              <TimeField
                :time.sync="offSaleTime"
                :valid.sync="offSaleTimeValid"
                :disabled="disable"
                @change="offSaleDateTimeChanged"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
@import "@/assets/variables.scss";

.tier-row {
  margin-bottom: 1em;
}

.delete {
  margin-top: 20px;
}

div.dates {
  padding-left: 0;
}

div.date {
  padding: 5px 10px;
  border-radius: $radius;
  display: inline-block;
  margin: 5px;
}

div.date:hover {
  background: $gray6;
}

div.date.selected {
  background: $gold;
}

.sale-controls {
  margin-top: 0.5em;
  margin-bottom: 0;
}

.sale-datetime {
  margin-top: 0;
  padding-left: 0;
}
</style>
<script>
import moment from "moment-timezone";
import firebase from "firebase/app";
import "firebase/firestore";
import TimeField from "@/components/formControls/time-field";

const localisation_us = {
  buttonLabel: "Choose date",
  placeholder: "MM/DD/YYYY",
  selectedDateMessage: "Selected date is",
  prevMonthLabel: "Previous month",
  nextMonthLabel: "Next month",
  monthSelectLabel: "Month",
  yearSelectLabel: "Year",
  closeLabel: "Close window",
  keyboardInstruction: "You can use arrow keys to navigate dates",
  calendarHeading: "Choose a date",
  dayNames: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ],
  monthNames: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ],
  monthNamesShort: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ]
};

export default {
  components: { TimeField },
  data() {
    return {
      datepickerId: "eventDate",
      times: [],
      localisation_us: localisation_us,
      setOnSale: false,
      setOffSale: false,
      onSaleDate: "",
      onSaleTime: "",
      offSaleDate: "",
      offSaleTime: "",
      onSaleTimeValid: true,
      offSaleTimeValid: true
    };
  },
  props: {
    tier: Object,
    type: String,
    flexible: Number,
    dates: Array,
    disable: Boolean,
    timezone: {
      type: String,
      default: "America/Chicago"
    }
  },
  created() {
    if (this.tier.id) {
      this.datepickerId = "tier-" + this.tier.id;
    } else {
      this.datepickerId =
        "newTier-" + (Math.random() + 1).toString(36).substring(7);
    }
    this.initSaleDates();
  },
  methods: {
    initSaleDates() {
      if (this.tier.onSale) {
        this.setOnSale = true;
        const onSaleDate = this.tier.onSale.toDate
          ? this.tier.onSale.toDate()
          : new Date(this.tier.onSale);
        const onSaleMoment = moment(onSaleDate).tz(this.timezone);
        this.onSaleDate = onSaleMoment.format("YYYY-MM-DD");
        this.onSaleTime = onSaleMoment.format("HH:mm");
      }
      if (this.tier.offSale) {
        this.setOffSale = true;
        const offSaleDate = this.tier.offSale.toDate
          ? this.tier.offSale.toDate()
          : new Date(this.tier.offSale);
        const offSaleMoment = moment(offSaleDate).tz(this.timezone);
        this.offSaleDate = offSaleMoment.format("YYYY-MM-DD");
        this.offSaleTime = offSaleMoment.format("HH:mm");
      }
    },
    changed() {
      console.log("changed: " + JSON.stringify(this.tier));
      var pricingSet =
        this.tier.feeType == "free" ||
        this.tier.feeType == "tiers" ||
        (this.tier.feeType == "fixed" && this.tier.price > 0) ||
        (this.tier.feeType == "sliding" &&
          this.tier.minPrice > 0 &&
          this.tier.maxPrice > this.tier.minPrice);
      //console.log("Valid: ", this.valid(), "PricingSet: ", pricingSet);
      if (
        this.valid() &&
        pricingSet &&
        this.tier.name &&
        (this.tier.quantityType == "flexible" ||
          this.tier.capacity > 0 ||
          this.type == "donation")
      ) {
        console.log("Tier set");
        this.$emit("tierSet", this.tier);
      } else console.log("Invalid Tier", this.tier, pricingSet);
    },
    deleted() {
      console.log("deleting tier");
      this.$emit("deleted", this.tier);
    },
    valid() {
      if (
        this.tier.quantityType == "fixed" &&
        (this.tier.capacity < 1 || this.tier.capacity > 100000)
      )
        return false;
      if (this.tier.feeType == "fixed" && this.tier.price < 5) return false;
      if (this.tier.feeType == "sliding" && this.tier.minPrice < 5)
        return false;
      if (
        this.tier.feeType == "sliding" &&
        this.tier.maxPrice < this.tier.minPrice
      )
        return false;
      return true;
    },
    shortDate: function(date) {
      return moment(date).format("ddd, MMM Do");
    },
    toggleDate(date) {
      var selected = this.tier.selectedDates.indexOf(date.id) > -1;
      if (!this.tier.selectedDates) this.tier.selectedDates = [];
      if (!selected) this.tier.selectedDates.push(date.id);
      else
        this.tier.selectedDates.splice(
          this.tier.selectedDates.indexOf(date.id),
          1
        );
      this.changed();
    },
    onSaleToggled() {
      if (!this.setOnSale) {
        this.tier.onSale = null;
        this.onSaleDate = "";
        this.onSaleTime = "";
        this.changed();
      }
    },
    offSaleToggled() {
      if (!this.setOffSale) {
        this.tier.offSale = null;
        this.offSaleDate = "";
        this.offSaleTime = "";
        this.changed();
      }
    },
    updateOnSaleDate(e) {
      this.onSaleDate = e.detail.value;
      this.onSaleDateTimeChanged();
    },
    updateOffSaleDate(e) {
      this.offSaleDate = e.detail.value;
      this.offSaleDateTimeChanged();
    },
    onSaleDateTimeChanged() {
      if (this.onSaleDate && this.onSaleTime && this.onSaleTimeValid) {
        const dateTime = moment.tz(
          `${this.onSaleDate} ${this.onSaleTime}`,
          "YYYY-MM-DD HH:mm",
          this.timezone
        );
        this.tier.onSale = firebase.firestore.Timestamp.fromDate(
          dateTime.toDate()
        );
        this.changed();
      }
    },
    offSaleDateTimeChanged() {
      if (this.offSaleDate && this.offSaleTime && this.offSaleTimeValid) {
        const dateTime = moment.tz(
          `${this.offSaleDate} ${this.offSaleTime}`,
          "YYYY-MM-DD HH:mm",
          this.timezone
        );
        this.tier.offSale = firebase.firestore.Timestamp.fromDate(
          dateTime.toDate()
        );
        this.changed();
      }
    }
  }
};
</script>
